import { useTranslation } from "react-i18next";
import RobinPage from "../components/RobinPage";
import {
  useDeletePermissionMutation,
  useGetAllPermissionsQuery,
} from "../graphql/generated/hooks";
import { Button, Flex, Space, Table, Tooltip, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { ReloadOutlined } from "@ant-design/icons";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

function PermissionList() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: permissions, loading, refetch } = useGetAllPermissionsQuery();
  const [deletePermission] = useDeletePermissionMutation();
  const dataSource = permissions?.getAllPermissions?.map(
    (permission, index) => ({
      key: index,
      name: permission.name,
      role: permission.role,
      functions: permission.functions?.length || 0,
      actions: (
        <Flex gap="small">
          <Typography.Link
            onClick={() => {
              navigate(`/settings/permission/mutate/${permission.id}`, {
                state: { permission },
              });
            }}
          >
            <Tooltip title={t("button.edit")}>
              <EditOutlined />
            </Tooltip>
          </Typography.Link>
          <Typography.Link
            onClick={() => {
              deletePermission({ variables: { id: permission.id } }).then(
                () => {
                  refetch();
                }
              );
            }}
          >
            <Tooltip title={t("button.delete")}>
              <DeleteOutlined style={{ color: "red" }} />
            </Tooltip>
          </Typography.Link>
        </Flex>
      ),
    })
  );

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
    },
    {
      title: "Functions",
      dataIndex: "functions",
      key: "functions",
    },
    { title: "Actions", dataIndex: "actions", key: "actions" },
  ];
  return (
    <RobinPage
      title={t("label.menu.permission_list")}
      actions={
        <Space size="large">
          <Typography.Link
            onClick={() => {
              refetch();
            }}
          >
            <ReloadOutlined />
          </Typography.Link>
          <Button
            onClick={() => {
              navigate("/settings/permission/mutate");
            }}
          >
            {t("button.add")}
          </Button>
        </Space>
      }
    >
      <Table loading={loading} dataSource={dataSource} columns={columns} />
    </RobinPage>
  );
}

export default PermissionList;
